import { Link } from "react-router-dom"
import { ChevronDoubleRightIcon } from "@heroicons/react/24/outline"
import { H5, SmallParagraph, SmallText } from "../../components/typography/Typography"
import { ANALYTICS_EVENTS, track } from "../../lib/analytics"
import stadium from "../../assets/industries/stadium.png"
import auditorium from "../../assets/industries/auditorium.png"
import school from "../../assets/industries/school.png"
import corporate from "../../assets/industries/corporate.png"
import government from "../../assets/industries/government.png"

type IndustryItem = {
  href: string
  label: string
  subLabel: string
  image: string
  alt: string
}

const industries: IndustryItem[] = [
  { href: "/industries/stadium", label: "Stadium", subLabel: 'Outdoor Seating for Cricket Stadiums, Football Fields, and more', image: stadium, alt: "Stadium" },
  { href: "/industries/auditorium", label: "Auditorium", subLabel: 'Motorized Systems for Movie Theatres, Black Box Theatres', image: auditorium, alt: "Auditorium" },
  { href: "/industries/school", label: "School", subLabel: 'Motorized and Manual Gymnasium Bleachers for indoor and outdoor', image: school, alt: "School" },
  { href: "/industries/corporate", label: "Corporate", subLabel: 'Multi-purpose convention centers and halls', image: corporate, alt: "Corporate" },
  { href: "/industries/government", label: "Government", subLabel: 'Quick Installation and Warehousing for Events', image: government, alt: "Government" },
]

export const IndustriesPanel = ({ onClick }: { onClick: () => void }) => {
  const handleClick = (label: string, href: string) => {
    track(ANALYTICS_EVENTS.NAV_LINK_CLICKED, { label, href, surface: "industries_panel" })
    onClick()
  }

  return (
    <div className="md:flex md:flex-col lg:grid lg:grid-cols-3 gap-2 p-4">
      {industries.map(({ href, label, subLabel, image, alt }) => (
        <Link
          key={href}
          to={href}
          onClick={() => handleClick(label, href)}
          className="flex items-center gap-3 rounded-lg border border-gray-200 bg-white p-2 transition hover:bg-gray-50"
        >
          <img src={image} alt={alt} className="h-24 w-48 shrink-0 rounded object-cover" />
          <div className="flex flex-col gap-2">
            <SmallParagraph>{label}</SmallParagraph>
            <SmallText className="capitalize">{subLabel}</SmallText>
          </div>
        </Link>
      ))}
      <Link
        to="/industries"
        onClick={() => handleClick("Industries (view all)", "/industries")}
        className="flex items-center justify-center gap-1 rounded-lg border border-gray-200 bg-white p-2 transition hover:bg-gray-50"
      >
        <H5>View all</H5>
        <ChevronDoubleRightIcon aria-hidden="true" className="size-4" />
      </Link>
    </div>
  )
}
